import { Container } from "pixi.js";

import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { HighlightFrames } from "./HighlightFrames";

export class HighlightFramesComponent extends AbstractDisplayComponent {
    private winFrameContainer: Container;

    public override init() {
        let containerConfig = {
            labelName: "frames_container",
            anchorX: 0.5,
            anchorY: 0.5,
            landscape: {
                posX: -473,
                posY: -124,
                scale: 1,
            },
            portrait: {
                posX: -473,
                posY: -124,
                scale: 1,
            }
        };

        this.winFrameContainer = new HighlightFrames(containerConfig);
    }

    public getInstance(): Container {
        return this.winFrameContainer;
    }

    public override destroy(): void {
        this.winFrameContainer.destroy({ children: true });
    }
}
